import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class DocverHistoryService {

constructor(private _http: HttpClient) { }


getDocVersionHistoryList(docid:number): any {
  return this._http.get(environment.APIEndpoint +'api/DocVersionHist/GetDocVersionHistoryList?docId=' + docid)
    .map((res) => res)
    .catch(this._errorHandler);
}
_errorHandler(error: Response) {
  // tslint:disable-next-line: deprecation
  return Observable.throw(error || 'Server Error');
}

}
